// @flow

import {MASTER_CENTRIFUGE_ACTION_TYPES} from 'modules/centrifuge/constants';

const initialState = {
    connectionData: null,
    connectionInProgress: null,
    isConnected: false,
};

export const MasterCentrifugeReducer = (state = initialState, action) => {
    switch (action.type) {
        case MASTER_CENTRIFUGE_ACTION_TYPES.M_CENTRIFUGE_SET_CONN_DATA:
            return {
                ...state,
                connectionData: action.payload,
            };
        case MASTER_CENTRIFUGE_ACTION_TYPES.M_CENTRIFUGE_SET_IS_CONNECTED:
            return {
                ...state,
                isConnected: action.payload,
            };
        case MASTER_CENTRIFUGE_ACTION_TYPES.M_CENTRIFUGE_SET_IN_PROGRESS:
            return {
                ...state,
                connectionInProgress: action.payload,
            };
        default:
            return state;
    }
}